import { render, staticRenderFns } from "./AccessData.vue?vue&type=template&id=eceb24ce&scoped=true&"
import script from "./AccessData.vue?vue&type=script&lang=js&"
export * from "./AccessData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eceb24ce",
  null
  
)

export default component.exports